import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { JoonColorExpanded, Typography } from "@joonapp/web-shared"
import { JoonUIColor } from "@joonapp/web-shared"

import useMobile from "../../hooks/useMobile"
import NotificationDot2 from "../notificationDot/NotificationDot2"
const TabNavItem = ({
  label,
  onClick,
  icon,
  isSelected,
  showNotificationDot = false,
}: {
  label: string
  onClick: () => void
  icon: IconDefinition
  isSelected: boolean
  showNotificationDot?: boolean
}) => {
  const isMobile = useMobile()

  return (
    <button onClick={onClick}>
      <div className="flex flex-col text-left">
        <div className="flex flex-row items-center gap-2 py-2 px-2">
          <FontAwesomeIcon
            icon={icon}
            size="lg"
            color={
              isSelected ? JoonUIColor.icon.accent : JoonUIColor.icon.neutral
            }
            style={{
              // @ts-ignore
              "--fa-primary-color": isSelected
                ? JoonUIColor.icon.accent
                : JoonUIColor.icon.neutral,
              "--fa-secondary-color": isSelected
                ? JoonColorExpanded.indigo200
                : JoonUIColor.icon.light,
            }}
          />
          <div className="flex items-center gap-1">
            <Typography
              variant="body"
              color={
                isSelected
                  ? JoonUIColor.text.primary
                  : JoonUIColor.text.secondary
              }
              className="whitespace-nowrap"
            >
              {label}
            </Typography>
            {showNotificationDot && <NotificationDot2 />}
          </div>
        </div>
        <div
          className={`h-1 rounded-tl-[3px] rounded-tr-[3px] ${isSelected ? "bg-primary" : "bg-transparent"} ${
            !isMobile && "rounded-bl-[3px] rounded-br-[3px]"
          }`}
        />
      </div>
    </button>
  )
}

export default TabNavItem
